/// <reference path="../../_references.ts" />
module onvio.setup.list {
    'use strict';

    export interface IEngagementTemplateDomainModel extends bmp.IDomainModel,cs.IEngagementTemplateV2Dto {
        $status: cs.INamedReferenceDto;
        $isDefault: boolean;
    }

    export class EngagementTemplateDomainModel implements bmp.IDomainModel {
        // TODO - KMS - do we want to use bm-indirect-tax to pull in typings?
        // Type would be: BmIndirectTax.ITaxGroupSelectProvider
        public indirectTaxProvider: any;

        static $inject = [
        '$injector',
        '$translate',
        'fef.Utils',
        'bmpProviderUtils'];

        constructor(
            private $injector: ng.auto.IInjectorService,
            private $translate: ng.translate.ITranslateService,
            private utils: fef.IUtilsService,
            private providerUtils: bmp.IProviderUtilsService) {
            // We have made 'taxGroupSelectProvider' an optional dependency,
            // which means the injector needs to have the 'bm.indirect.tax' module
            // loaded ahead of time in order for it to be found here.
            try {
                this.indirectTaxProvider = $injector.get('taxGroupSelectProvider');
            } catch (e) {
                // taxGroupSelectProvider not loaded.
                this.indirectTaxProvider = undefined;
            }
        }

        initializeModel(contextId: cs.INamedReferenceDto, model: cs.IEngagementTemplateV2Dto,
            defaultModel: cs.IEngagementTemplateV2Dto): void {

            if (defaultModel.id === model.id) {
                //these IDs will match if the user is Adding a new engagement template
                //server requires these to ids to match,
                //and the Provider front end code requires the id be set to 'new' so it does a POST instead of a PUT
                model.id = this.providerUtils.newId();
                //model.engagement.engagementTemplate.id = this.providerUtils.newId();
            }

            var typedModel = <IEngagementTemplateDomainModel>model;
            Object.defineProperty(
                model,
                '$status',
                {
                    get: () => {
                        return typedModel.status;
                    },
                    set: (value: any) => {
                        if (typedModel.status === value) {
                            return;
                        }
                        typedModel.status = value;
                        if (typedModel.status.id === 'INACTIVE') {
                            typedModel.isDefault = false;
                        }
                    }
                });
            Object.defineProperty(
                model,
                '$isDefault',
                {
                    get: () => {
                        return typedModel.isDefault;
                    },
                    set: (value: any) => {
                        if (typedModel.isDefault === value) {
                            return;
                        }
                        typedModel.isDefault = value;
                        if (typedModel.isDefault) {
                            typedModel.$status = { id: 'ACTIVE' };
                        }
                    }
                });
        }

        finalizeModel(contextId: cs.INamedReferenceDto, model: cs.IEngagementTemplateV2Dto,
            defaultModel: cs.IEngagementTemplateV2Dto): void {
            console.log('this block was empty');
        }

        _validModel(model: cs.IEngagementTemplateV2Dto): boolean {
            return model !== null && model !== undefined;
        }

        shouldSpecifyOffice(
            model: cs.IEngagementTemplateV2Dto
            ): boolean {
            return this._validModel(model) &&
                model.officeGroup.id === 'SPECIFIEDOFFICE';
        }

        shouldSpecifyBillerEmployee(
            model: cs.IEngagementTemplateV2Dto
            ): boolean {
            return this._validModel(model) &&
            model.billerGroup.id === 'SPECIFIEDEMPLOYEE';
        }

        shouldSpecifyReviewerEmployee(
            model: cs.IEngagementTemplateV2Dto
            ): boolean {
            return this._validModel(model) &&
                model.reviewerGroup.id === 'SPECIFIEDEMPLOYEE';
        }

        shouldSpecifyManagerEmployee(
            model: cs.IEngagementTemplateV2Dto
            ): boolean {
            return this._validModel(model) &&
                model.managerGroup.id === 'SPECIFIEDEMPLOYEE';
        }

        shouldSpecifyEmployeeRateDescription(
            model: cs.IEngagementTemplateV2Dto): boolean {
                return this._validModel(model) &&
                    model.rateType.id === 'EMPLOYEERATE';
        }

        showFixedRate(
            model: cs.IEngagementTemplateV2Dto): boolean {
            return this._validModel(model) &&
                model.rateType.id === 'FIXEDRATE';
        }

        showFixedSurcharge(
            model: cs.IEngagementTemplateV2Dto): boolean {
            return this._validModel(model) &&
                model.surchargeMethod.id === 'FIXEDAMOUNT';
        }

        onFixedSurchargeChanged(model: cs.IEngagementTemplateV2Dto) {
            if (!this._validModel(model)) {
                return;
            }
            if (model.surchargeMethod.id !== 'FIXEDAMOUNT') {
                model.surchargeAmount = '0';
            }
        }

        onRateTypeChanged(model: cs.IEngagementTemplateV2Dto) {
            if (!this._validModel(model)) {
                return;
            }
            if (model.rateType.id !== 'FIXEDRATE') {
                model.fixedRate = '0';
            }
            if (model.rateType.id !== 'EMPLOYEERATE') {
                model.employeeRateDescription = null;
            }
        }

        public statusOptions: string[] = ['ACTIVE', 'INACTIVE'];

        showTaxGroup(model: cs.IScheduleItemV4Dto): boolean {
            return this.utils.exists(this.indirectTaxProvider);
        }
    }

    var setupModule = angular.module(
        'onvio.setup.list.EngagementTemplate',
        [
            'pascalprecht.translate',
            'fef',
            'bmpProviderUtils'
        ]);

    setupModule.service('onvio.setup.list.EngagementTemplate.DomainModel', EngagementTemplateDomainModel);
}
